import { useContext } from "react";
import { AuthContext, AuthContextProps } from "./context";

export function useAuth(): AuthContextProps {
    return useContext(AuthContext);
}
